export enum KitchenRenderMode {
    FOOD,
    BEVERAGES,
}
